var map = {
	"./Maxwell_Portrait.png": 32,
	"./WX-78_Portrait.png": 33,
	"./Wagstaff_Portrait.png": 34,
	"./Walani_Portrait.png": 35,
	"./Walter_Portrait.png": 36,
	"./Wanda_Portrait.png": 37,
	"./Warly_Portrait.png": 21,
	"./Webber_Portrait.png": 38,
	"./Wendy_Portrait.png": 39,
	"./Wes_Portrait.png": 40,
	"./Wheeler_Portrait.png": 41,
	"./Wickerbottom_Portrait.png": 42,
	"./Wigfrid_Portrait.png": 43,
	"./Wilba_Portrait.png": 44,
	"./Wilbur_Portrait.png": 45,
	"./Willow_Portrait.png": 46,
	"./Wilson_Portrait.png": 47,
	"./Winona_Portrait.png": 48,
	"./Wolfgang_Portrait.png": 49,
	"./Woodie_Portrait.png": 50,
	"./Woodlegs_Portrait.png": 51,
	"./Wormwood_Portrait.png": 52,
	"./Wortox_Portrait.png": 53,
	"./Wurt_Portrait.png": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;